import axios from "axios";
import jwtDecode from "jwt-decode";
import { del, get, post } from "../common/apiClient";
import {
  localStorageGetItem,
  localStorageSetItem,
} from "../common/localStorage";

const PATH_AUTH = "/auth";

const register = async (body) => {
  return await post(PATH_AUTH + "/signup", body);
};

const login = async (body) => {
  return await post(PATH_AUTH + "/login", body);
};

const loginWithGoogle = async (accessToken) => {
  return await post(
    PATH_AUTH + "/google-login",
    {
      accessToken,
    },
    {
      withCredentials: true,
    }
  );
};

const forgotPassword = async (body) => {
  return await post(PATH_AUTH + "/forgot-password", body);
};

const resetPassword = async (body) => {
  return await post(PATH_AUTH + "/reset-password", body);
};

const checkJwtExistsAndExpired = () => {
  const jwt = localStorageGetItem("jwt");
  if (!jwt || !jwt?.token) {
    return false;
  }

  try {
    const { exp } = jwtDecode(jwt?.token);
    const now = Date.now() / 1000;
    return exp && exp > now; // Chỉ kiểm tra token còn hạn
  } catch (err) {
    return false;
  }
};

const getUserInfo = () => {
  return localStorageGetItem("user");
};

// Session management functions
const getUserSessions = async () => {
  return await get(PATH_AUTH + "/sessions");
};

const logoutSession = async () => {
  return await del(PATH_AUTH + `/sessions`);
};

const logoutAllSessions = async () => {
  return await post(PATH_AUTH + "/logout-all");
};

export {
  register,
  login,
  forgotPassword,
  resetPassword,
  checkJwtExistsAndExpired,
  loginWithGoogle,
  getUserInfo,
  getUserSessions,
  logoutSession,
  logoutAllSessions,
};
